<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-pokeball`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22s-9.85 22-22 22S2 36.15 2 24 11.85 2 24 2zm17.89 24h-5.043C35.885 32.23 30.499 37 24 37c-6.5 0-11.885-4.77-12.847-11H6.11c.995 9 8.625 16 17.89 16s16.895-7 17.89-16zM15 24a9 9 0 1118 0 9 9 0 01-18 0zm9-5a5 5 0 110 10 5 5 0 010-10zM6.11 22C7.104 13 14.735 6 24 6s16.896 7 17.89 16h-5.043C35.885 15.77 30.5 11 24 11c-6.5 0-11.885 4.77-12.847 11H6.11z"/></svg>
</template>
<script>

export default {
  name: 'IconPokeball',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
